<template>
  <div class="comment__main-block">
    <div class="comment__main-block-header-content">
      <BaseSubHeading
        size="medium"
        weight="500"
        color="markingBlue-02"
        darkColor="markingBlue-03"
        class="comment__main-block-header-content-status"
      >
        Restored
      </BaseSubHeading>

      <BaseSubHeading
        size="medium"
        weight="400"
        class="comment__main-block-header-content-description"
      >
        {{ afterTask.name }}
      </BaseSubHeading>
      <BaseSubHeading
        size="medium"
        weight="500"
        class="comment__main-block-header-content-type"
      >
        {{ formattedTaskType }}
      </BaseSubHeading>

      <BaseSubHeading
        weight="500"
        size="small"
        class="comment__main-block-header-content-time"
      >
        {{ afterTask.estimatedHours }} hr
      </BaseSubHeading>
      <span class="comment__main-block-header-content-task-owner">
        <Avatar
          v-tooltip.bottom="{
            content: afterTask.owner?.username,
            theme: 'info-tooltip-sm'
          }"
          :src="afterTask.owner?.pictureUrl ?? null"
          :gap="afterTask?.owner?.getInitials()"
          size="md"
          type="avatarGroup"
          class="avatar-img"
        />
      </span>
    </div>
    <div
      v-if="afterTask.structuredDescription?.getTextFromHtml"
      class="comment__main-block-content"
    >
      <span class="comment__main-block-content-text">
        {{ afterTask.structuredDescription.getTextFromHtml }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import Avatar from "@/components/Avatar/index.vue"

import { Comment, Task } from "@/models"
import { $t } from "@/plugins/i18n"

import type { PropType } from "vue"

const props = defineProps({
  comment: {
    type: Object as PropType<Comment>,
    required: true
  }
})
const formattedTaskType = computed(() => {
  const type = afterTask.value?.type
  if (!type) return ""
  return $t(`cycleTimeByTaskType.${type}`)
})

const afterTask = computed(() => {
  const taskAfter = props.comment.itemAuditRecord?.taskAfter
  return Task.create(taskAfter ?? undefined)
})
</script>

<style scoped lang="scss">
@import "@/assets/scss/utils/mixins/_ellipsis";
@import "@/assets/scss/utils/mixins/_flex";

.comment__main-block {
  @include flex($direction: column);

  gap: var(--step2);
}

.comment__main-block-header-content-task-owner {
  > div:first-child {
    background: var(--accent-03);
  }
}

.comment__main-block-header-content {
  display: grid;
  align-items: center;
  gap: var(--step2);
  grid-template-columns: 64px 1fr max-content 78px 58px;

  &-description {
    @include ellipsis;
  }

  &-type {
    width: max-content;
    min-width: 40px;
    margin-left: var(--step2);
    text-align: center;
  }

  &-time {
    @include flex($direction: row, $align: center, $justify: center);

    height: 18px;
    border-radius: 2px;
    margin-left: var(--step2);
    background: var(--monochrome-01);
    gap: 2px;
    line-height: 1;
  }

  &-task-owner {
    margin-left: var(--step2);

    @include flex($justify: center, $align: center);
  }
}

.comment__main-block-content {
  display: grid;
  max-width: 100%;
  grid-template-columns: 1fr auto;

  @include ellipsis;

  &-text {
    @include ellipsis;
  }
}

.comment__main-block-footer {
  @include flex($align: baseline);

  gap: var(--step3);
}

.separator {
  display: flex;
  height: 100%;
  align-items: center;
  font-size: 18px;
  line-height: 1;
}
</style>
